import { render } from "./team.vue?vue&type=template&id=63134e42"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"

import "./team.vue?vue&type=style&index=0&id=63134e42&lang=scss"

import exportComponent from "/usr/src/app/frontend_result/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__